export default class User {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  setToken(params) {
    return this.apiClient.setToken(params);
  }

  async join(params) {
    return this.apiClient.join(params);
  }

  async login(params, token) {
    return this.apiClient.login(params, token);
  }

  async logout() {
    return this.apiClient.logout();
  }

  async getDetail() {
    return this.apiClient.getDetail();
  }

  async delete(params) {
    return this.apiClient.delete(params);
  }

  async changeMarketingAgree(params) {
    return this.apiClient.changeMarketingAgree(params);
  }

  async addAccount(params) {
    return this.apiClient.addAccount(params);
  }

  async addSecurityNumber(params) {
    return this.apiClient.addSecurityNumber(params);
  }

  /**
   * 상조 전용 메서드
   * getDirectorList - 소속된 장례지도사 조회

   */
  async getDirectorList(params) {
    return this.apiClient.getDirectorList(params);
  }

  /**
   * 장례지도사 전용 메서드
   * addCorp - 상조추가
   * applyCorp - 적용된 상조 변경
   */

  async addCorp(params) {
    return this.apiClient.addCorp(params);
  }

  async applyCorp(params) {
    return this.apiClient.applyCorp(params);
  }

  async deleteCorpDirector(params) {
    return this.apiClient.deleteCorpDirector(params);
  }
}
